"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSpecialWindow = exports.allTimeDateWindow = exports.ALL_TIME_DATE_WINDOW = exports.SpecialDateWindowType = void 0;
var core_1 = require("../core");
var SpecialDateWindowType;
(function (SpecialDateWindowType) {
    SpecialDateWindowType["ALL_TIME"] = "all-time";
})(SpecialDateWindowType = exports.SpecialDateWindowType || (exports.SpecialDateWindowType = {}));
exports.ALL_TIME_DATE_WINDOW = {
    specialType: SpecialDateWindowType.ALL_TIME,
    type: core_1.DateWindowTypes.SPECIAL,
};
var allTimeDateWindow = function () {
    return function (table) { return table; };
};
exports.allTimeDateWindow = allTimeDateWindow;
var createSpecialWindow = function (specialType) {
    return {
        type: core_1.DateWindowTypes.SPECIAL,
        specialType: specialType,
    };
};
exports.createSpecialWindow = createSpecialWindow;
//# sourceMappingURL=allTimeDateWindow.js.map